import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Style from './style.module.scss';

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <div className={Style.container}>
      <div className={Style.content}>
        <h1 className={Style.title}>404</h1>
        <p className={Style.message}>{t('notFoundPage.title')}</p>
        <p className={Style.description}>{t('notFoundPage.description')}</p>
        <Link to="/" className={Style.button}>
          {t('notFoundPage.button')}
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
